
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { updateChatQuestion } from "../../../features/aiControl/aiControlSlice"
import AIQuestionItemUpdate from "../../aiControl/AIQuestionItemUpdate"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .wrapper{
            width: 100%;
            padding: 30px;
        }

        .content{
            width: 100%;
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 10px;

            .top-container{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 5px;

                .title-name{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                }

            }

            .question-list{
                border: 2px solid ${({theme}) => theme.mainBorderColor};
                width: 100%;
                border-radius: 10px;
                margin-bottom: 20px;

                .add-btn{
                    width: 100%;
                    background-color: ${({theme}) => theme.mainBorderColor};
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items:center;
                    font-size: 3.4rem;
                    color: #fff;
                }
            }
            
            .btn-container{
                width: 100%;
                display: flex;
                justify-content: center;
                gap: 20px;
            }
        }
    }
`
const UpdateAIQuestionsModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const { lockScroll, unlockScroll } = useScrollLock();

    const {updateQuestionsList, constantUpdateQuestionsList, updateQuestionsTitleData} = useSelector(state => state.aiControl)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        const filtered = updateQuestionsList.filter((item) => {
          const jsonString1 = JSON.stringify(item);
          const jsonString2 = JSON.stringify(constantUpdateQuestionsList.find(innerItem => innerItem.id === item.id));
          return jsonString1 !== jsonString2
        })
  

        const formattedData = filtered.map(item => {
            return {id: item.id, answer: item.answer, question: item.question, isActive:item.isActive}
        })

        dispatch(updateChatQuestion({
            aidefaultMesssages: formattedData
        }))
      }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="wrapper">
            <div className="content">
                <div className="top-container">
                    <div className="title-name">{updateQuestionsTitleData.title}</div>
                    {/* <Btn bgColor="#E85446" width={"120px"} height="30px" color="#fff" handleClick={()=> {}}>Tüm Grubu Sil</Btn> */}
                </div>
                <div className="question-list">
                    {
                        updateQuestionsList.map((item, i) => (
                            <AIQuestionItemUpdate item={item} order={i+1} isItLast={i+1 === updateQuestionsList.length}/>
                        ))
                    }
                </div>
                <div className="btn-container">
                    <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={handleSubmit}>Güncelle</Btn>
                    <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
                </div>
            </div>
        </div>
    </div>
</ModalContainer>
  )
}

export default UpdateAIQuestionsModal